//alarm
export default {
    "id": 11662,
    "name_categorie": "Alert",
    "motive_categorie": "persontest",
    "tag": "person",
    "eventId": null,
    "deviceId": "debe49d6-5245-4de6-9355-c4ae78b30cf0",
    "analytic": "tracker",
    "probability": "0.5360",
    "vinfo":JSON.stringify({
    "id": 24,
    "name": "testRules",
    "state": true,
    "color": "#D11010FF",
    "sound": "alert",
    "is_active_rules": null,
    "createdAt": "2023-10-25T01:49:37.778Z",
    "updatedAt": "2023-10-25T01:49:37.778Z",
    "Detail_device_alarm": [
        {
            "id": 137,
            "state": true,
            "createdAt": "2023-10-25T01:49:37.841Z",
            "updatedAt": "2023-10-25T01:49:37.841Z",
            "alarmId": 24,
            "deviceId": "eb472da9-ade8-48c3-8bf8-e9a481654b74",
            "detail_roi_device": [
                {
                    "id": 137,
                    "state": true,
                    "points": "{\"point1\":[\"0.0102\",\"0.0160\"],\"point2\":[\"0.9918\",\"0.0160\"],\"point3\":[\"0.9918\",\"0.9840\"],\"point4\":[\"0.0102\",\"0.9840\"]}",
                    "createdAt": "2023-10-25T01:49:37.853Z",
                    "updatedAt": "2023-10-25T01:49:37.853Z",
                    "Detail_roi_device_alarmId": 137
                }
            ],
            "detail_schedule_device": [
                {
                    "id": 137,
                    "state": null,
                    "interval": "daily",
                    "start": "00:00:00",
                    "end": "23:59:00",
                    "timeZone": "",
                    "createdAt": "2023-10-25T01:49:37.860Z",
                    "updatedAt": "2023-10-25T01:49:37.860Z",
                    "Detail_shedule_devic": 137
                }
            ]
        },
        {
            "id": 136,
            "state": true,
            "createdAt": "2023-10-25T01:49:37.797Z",
            "updatedAt": "2023-10-25T01:49:37.797Z",
            "alarmId": 24,
            "deviceId": "a20db1b1-468c-42d7-9945-09a9e2be33f5",
            "detail_roi_device": [
                {
                    "id": 136,
                    "state": true,
                    "points": "{\"point1\":[\"0.0102\",\"0.0160\"],\"point2\":[\"0.9918\",\"0.0160\"],\"point3\":[\"0.9918\",\"0.9840\"],\"point4\":[\"0.0102\",\"0.9840\"]}",
                    "createdAt": "2023-10-25T01:49:37.830Z",
                    "updatedAt": "2023-10-25T01:49:37.830Z",
                    "Detail_roi_device_alarmId": 136
                }
            ],
            "detail_schedule_device": [
                {
                    "id": 136,
                    "state": null,
                    "interval": "daily",
                    "start": "00:00:00",
                    "end": "23:59:00",
                    "timeZone": "",
                    "createdAt": "2023-10-25T01:49:37.835Z",
                    "updatedAt": "2023-10-25T01:49:37.835Z",
                    "Detail_shedule_devic": 136
                }
            ]
        }
    ],
    "Detail_action_alarm": [
        {
            "id": 20,
            "state": null,
            "ismodal": true,
            "isnotificable": true,
            "issendtows": true,
            "issendemail": true,
            "issound": true,
            "isalert": true,
            "manual_confirmation": false,
            "timeout": 5,
            "createdAt": "2023-10-25T01:49:37.894Z",
            "updatedAt": "2023-10-25T01:49:37.894Z",
            "alarmId": 24
        }
    ],
    "Detail_motion_alarm": [
        {
            "id": 12,
            "state": true,
            "createdAt": "2023-10-25T01:49:37.866Z",
            "updatedAt": "2023-10-25T01:49:37.866Z",
            "alarmId": 24
        }
    ],
    "Detail_rule_face__alarm": [
        {
            "id": 12,
            "state": true,
            "entity": "2065a1b1-dfc9-4b12-844d-0cb0395b5c74",
            "access": "40",
            "prob": "40",
            "idList": null,
            "createdAt": "2023-10-25T01:49:37.886Z",
            "updatedAt": "2023-10-25T01:49:37.886Z",
            "alarmId": 24
        },
        {
            "id": 11,
            "state": true,
            "entity": null,
            "access": "40",
            "prob": "40",
            "idList": 4,
            "createdAt": "2023-10-25T01:49:37.882Z",
            "updatedAt": "2023-10-25T01:49:37.882Z",
            "alarmId": 24
        }
    ],
    "Detail_rule_lpr__alarm": [
        {
            "id": 7,
            "state": true,
            "idList": "6",
            "type": "lpr",
            "createdAt": "2023-10-25T01:49:37.877Z",
            "updatedAt": "2023-10-25T01:49:37.877Z",
            "alarmId": 24
        }
    ],
    "Detail_rule_obj_alarm": [
        {
            "id": 20,
            "state": true,
            "tag": "gun",
            "alertime": "0.2",
            "prob": "40",
            "countag": "1",
            "side": "-1",
            "way": "ALL",
            "createdAt": "2023-10-25T01:49:37.870Z",
            "updatedAt": "2023-10-25T01:49:37.870Z",
            "alarmId": 24
        }
    ],
    "Detail_rule_action_alarm": [
        {
            "id": 3,
            "state": true,
            "tag": "hands_up",
            "prob": "40",
            "createdAt": "2023-10-25T01:49:37.888Z",
            "updatedAt": "2023-10-25T01:49:37.888Z",
            "alarmId": 24
        }
    ]
}), 
    //"{\"id\":34,\"name\":\"persontest\",\"state\":true,\"color\":\"\",\"sound\":\"success\",\"is_active_rules\":null,\"createdAt\":\"2023-10-19T05:51:56.201Z\",\"updatedAt\":\"2023-10-19T05:51:56.201Z\",\"Detail_device_alarm\":[{\"id\":42,\"state\":true,\"createdAt\":\"2023-10-19T05:51:56.304Z\",\"updatedAt\":\"2023-10-19T05:51:56.304Z\",\"alarmId\":34,\"deviceId\":\"debe49d6-5245-4de6-9355-c4ae78b30cf0\",\"detail_roi_device\":[{\"id\":42,\"state\":true,\"points\":\"{\\\"point1\\\":[\\\"0.0102\\\",\\\"0.0160\\\"],\\\"point2\\\":[\\\"0.9918\\\",\\\"0.0160\\\"],\\\"point3\\\":[\\\"0.9918\\\",\\\"0.9840\\\"],\\\"point4\\\":[\\\"0.0102\\\",\\\"0.9840\\\"]}\",\"createdAt\":\"2023-10-19T05:51:56.334Z\",\"updatedAt\":\"2023-10-19T05:51:56.334Z\",\"Detail_roi_device_alarmId\":42}],\"detail_schedule_device\":[{\"id\":42,\"state\":null,\"interval\":\"daily\",\"start\":\"00:00:00\",\"end\":\"23:59:00\",\"timeZone\":\"\",\"createdAt\":\"2023-10-19T05:51:56.397Z\",\"updatedAt\":\"2023-10-19T05:51:56.397Z\",\"Detail_shedule_devic\":42}]}],\"Detail_action_alarm\":[{\"id\":34,\"state\":null,\"ismodal\":true,\"isnotificable\":true,\"issendtows\":true,\"issendemail\":true,\"issound\":true,\"isalert\":true,\"manual_confirmation\":false,\"timeout\":5,\"createdAt\":\"2023-10-19T05:51:56.650Z\",\"updatedAt\":\"2023-10-19T05:51:56.650Z\",\"alarmId\":34,\"detail_action_device\":[]}],\"Detail_motion_alarm\":[],\"Detail_rule_face__alarm\":[],\"Detail_rule_lpr__alarm\":[],\"Detail_rule_obj_alarm\":[{\"id\":15,\"state\":true,\"tag\":\"person\",\"alertime\":\"0.2\",\"prob\":\"40\",\"countag\":\"1\",\"side\":\"-1\",\"way\":\"ALL\",\"createdAt\":\"2023-10-19T05:51:56.450Z\",\"updatedAt\":\"2023-10-19T05:51:56.450Z\",\"alarmId\":34}],\"Detail_rule_action_alarm\":[]}",
    "url_evidence": "/alice-media/tracker/10_19_2023/debe49d6-5245-4de6-9355-c4ae78b30cf0/05/1697694741572_debe49d6-5245-4de6-9355-c4ae78b30cf0_fullImg.jpg",
    "path_evidence": "/opt/alice-media/tracker/10_19_2023/debe49d6-5245-4de6-9355-c4ae78b30cf0/05/1697694741572_debe49d6-5245-4de6-9355-c4ae78b30cf0_fullImg.jpg",
    "bbox": "{\"h\":\"0.3849\",\"w\":\"0.0389\",\"x\":\"0.2269\",\"y\":\"0.3158\"}",
    "unix_itme_stamp": "1697694741882",
    "ruleId": 34,
    "is_confirmed": null,
    "is_ignored": false,
    "is_fp": false,
    "side": "-1",
    "way": "ALL",
    "owner": null,
    "profileId": null,
    "gif_evidence": "/opt/alice-media/action_/debe49d6-5245-4de6-9355-c4ae78b30cf0/2023/10/18/8/1697694741882/action_1697694741882_debe49d6-5245-4de6-9355-c4ae78b30cf0.gif",
    "createdAt": "2023-10-19T05:52:22.015Z",
    "updatedAt": "2023-10-19T05:52:22.015Z",
    "Management_incident": [
        {
            "id": 13877,
            "name": "Automatic actions",
            "eventId": 11662,
            "caseId": null,
            "contact": "",
            "userId": 1,
            "deviceId": "debe49d6-5245-4de6-9355-c4ae78b30cf0",
            "type": "tracker",
            "state": "active",
            "date": "1697694741882",
            "description": "Automatic actions",
            "createdAt": "2023-10-19T05:52:22.192Z",
            "updatedAt": "2023-10-19T05:52:22.192Z",
            "descriptions": []
        }
    ],
    "userId": 1
}